<template>
    <v-container fill-height fluid>
        <v-row class="justify-center align-center fill-height">
            <v-col class="fill-height">
                <v-card light>
                    <v-toolbar dark color="secondary" :elevation="1">
                        <v-toolbar-title>Edit {{user.email}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" autocomplete="off">
                            <v-alert
                                color="error"
                                dark
                                elevation="2"
                                type="error"
                                :value="!!error_message.length"
                                transition="fade-transition"
                                dismissible
                            >{{ error_message }}</v-alert>
                            <v-text-field
                                v-model="email"
                                :rules="[rules.required, rules.valid_email]"
                                label="E-mail"
                                name="email"
                                required
								disabled
                            ></v-text-field>
                            <v-text-field
                                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required]"
                                :type="show_password ? 'text' : 'password'"
                                name="password"
                                label="New Password"
                                v-model="password"
                                class="input-group--focused required"
                                @click:append="show_password = !show_password"
                                required
                            ></v-text-field>
                            <v-text-field
                                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="passwordConfirmationRules"
                                :type="show_password ? 'text' : 'password'"
                                name="confirm_password"
                                label="Confirm New Password"
                                v-model="repassword"
                                class="input-group--focused required"
                                @click:append="show_password = !show_password"
                                required
                            ></v-text-field>
                            <v-btn
                                :disabled="!valid"
                                color="primary"
                                class="mr-4"
                                @click="updateUser"
                            >Update</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UsersService from '@/services/users'
export default {
	name: 'NewUser',
	data: () => ({
		error_message: '',
		valid: true,
		email: '',
		password: '',
		repassword: '',
		show_password: false,
		rules: {
			required: v => !!v || 'Required.',
			valid_email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
		}
	}),
	computed: {
		passwordConfirmationRules() {
			return [
				() =>
					this.password === this.repassword || 'Passwords must match',
				v => !!v || 'Confirmation E-mail is required'
			]
		},
		user() {
			return this.$store.getters.user
		}
	},
	beforeMount() {
		this.email = this.user.email
	},
	methods: {
		async updateUser() {
			try {
				const newUser = {
					...this.user,
					password: this.password
				}
				await UsersService.updateUser(newUser)
				this.$router.push({ name: 'Users' })
			} catch (e) {
				console.error(e.response.data)
				this.error_message = e.response.data.message
					? e.response.data.message
					: 'An Error Occurred'
				setTimeout(() => {
					this.error_message = ''
				}, 4000)
			}
		}
	}
}
</script>